import styled from 'styled-components';
import DateCellProps from './type';
import Typography from '../../../Typography';

export const DateCellStyled = styled(Typography)<DateCellProps>`
  display: flex;
  justify-content: center;
`;
